import { render, staticRenderFns } from "./RemindPasswordForm.vue?vue&type=template&id=2f4d5c32&scoped=true&"
import script from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./RemindPasswordForm.vue?vue&type=style&index=0&id=2f4d5c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d5c32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
